import React, { useState, useEffect } from 'react'

// css
import 'assets/style/elements/tab.scss'

function Element({ className, type = 'line', data = [], clickTab = () => {}, cntYn = false }) {
  const typeClass = 'tab-' + type
  return (
    <div className={`tab ${typeClass} ` + className}>
      {data.map((item, index) => (
        <button
          className={`item ${item.active ? ' active' : ''}`}
          onClick={() => {
            clickTab(item.id, index)
          }}
          key={`tab_${index}`}
        >
          {item.text}
        </button>
      ))}
    </div>
  )
}

export default Element
